import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { metaDataApi } from "../api/metaDataApi";

export const useCategories = () => {
  return useQuery({
    queryKey: ["categories"],
    queryFn: metaDataApi.getAllCategories,
  });
};
export const useColors = () => {
  return useQuery({
    queryKey: ["colors"],
    queryFn: metaDataApi.getAllColors,
  });
};
export const useMaterials = () => {
  return useQuery({
    queryKey: ["materials"],
    queryFn: metaDataApi.getAllMaterials,
  });
};

export const useSizeGuides = () => {
  return useQuery({
    queryKey: ["size-guides"],
    queryFn: metaDataApi.getAllSizeGuides,
  });
};

export const useSizes = () => {
  return useQuery({
    queryKey: ["sizes"],
    queryFn: metaDataApi.getAllSizes,
  });
};

export const useCollections = () => {
  return useQuery({
    queryKey: ["collections"],
    queryFn: metaDataApi.getAllCollections,
  });
};

export const useOccasions = () => {
  return useQuery({
    queryKey: ["occasions"],
    queryFn: metaDataApi.getAllOccasions,
  });
};

export const useCreateSize = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ name, order }: { name: string; order: number }) => metaDataApi.createSize(name, order),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['sizes'] }),
  })
}

export const useCreateMaterial = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (name: string) => metaDataApi.createMaterial(name),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['materials'] }),
  })
}

export const useCreateColor = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({ name, hexValue }: { name: string; hexValue: string }) => metaDataApi.createColor(name, hexValue),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['colors'] }),
  })
}